{
  "menuLabel": "Logging Setup",
  "apiKeys": "API Keys",
  "docs": {
    "mezmoAgent": "Mezmo Agent",
    "laIntegrations": "Log Analysis Integrations",
    "otelNew": "New Collector",
    "otelHelmChart": "New Collector via Helm Chart",
    "existingOtel": "Configure existing Collector"
  },
  "otelDocumentation": "OpenTelemetry Documentation",
  "mezmoAgentDocumentation": "Legacy Agent Documentation",
  "testData": "Send Test Data",
  "tabs": {
    "otelLogs": "Otel Logs",
    "otelTraces": "Otel Traces",
    "otelMetrics": "Otel Metrics",
    "mezmoAgent": "Mezmo Log Agent"
  },
  "ingestionKey": "Your Ingestion key is:",
  "syslogLegalDisclaimer": "To configure syslog, you may need to enable a port to send logs via syslog to your logging instance.   If you are using (a) the classic syslog protocol, (b) a custom port in syslog-ng, or (c) a custom port in rsyslog, there is no authentication available and anyone with knowledge of the endpoint can submit logs to your instance. As a result, depending on your environment, your use of the classic syslog protocol or custom port configurations with syslog-ng or rsyslog may present a significant security risk.  Use these configurations at your organization's own risk. Validate with your compliance and security teams whether this security risk is acceptable to your organization.",
  "syslogSecurityWarning": "Please note that our rsyslog, syslog-ng and syslog forwarders are not authenticated and your data in-flight could be accessed by any 3rd party. Use these configurations at your organization’s own risk. Validate with your compliance and security teams whether this security risk is acceptable to your organization.",
  "testDataDescription": "Copy the following command to your terminal and press Enter to send test data to your instance."
}